import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components";

// The chrome every public page shares: the sticky nav pill and the one-line footer. Pages pass their
// own in-page links as children; the footer carries the legal and changelog links.

export const publicLinks = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/changelog", label: "Changelog" },
] as const;

export function NoirBar({ children, pill = { to: "/start", label: "Plug in an agent" } }: { children?: ReactNode; pill?: { to: string; label: string } }) {
  return (
    <header className="noir__bar">
      <nav className="noir__nav" aria-label="Public navigation">
        <Link className="noir__brand" to="/" aria-label="LoopGroup home">
          <i className="noir__dot" aria-hidden="true" />
          <Logo />
        </Link>
        <div className="noir__nav-actions">
          {children}
          <Link className="noir__navlink" to="/signin">Sign in</Link>
          <Link className="noir__pill" to={pill.to}>{pill.label}</Link>
        </div>
      </nav>
    </header>
  );
}

export function NoirFooter() {
  return (
    <footer className="noir__footer">
      <Logo />
      <p>Use any agent. Keep your loops.</p>
      <div className="noir__footer-meta">
        <nav className="noir__footer-links" aria-label="Policies and updates">
          {publicLinks.map((link, index) => (
            <span key={link.to}>
              {index > 0 && <i aria-hidden="true">·</i>}
              <Link to={link.to}>{link.label}</Link>
            </span>
          ))}
        </nav>
        <span>© 2026 LoopGroup</span>
      </div>
    </footer>
  );
}
